// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorPage_errorContainer__gkqLD","text":"ErrorPage_text__QR2-P"};